import { Controller } from '@hotwired/stimulus'
import { throttle } from '~/utils/throttle'

const SCROLL_KEY = 'sidebar-scroll-position'

export default class extends Controller {
  static targets = ['menu']
  static values = { opened: { type: Boolean, default: false } }

  connect () {
    this.saveScroll = throttle(() => this.#saveScrollPosition(), 500)
    this.handleBeforeVisit = () => {
      this.#saveScrollPosition()
      this.openedValue = false
    }

    this.#restoreScrollPosition()

    if (this.hasMenuTarget) {
      this.menuTarget.addEventListener('scroll', this.saveScroll)
    }
    document.addEventListener('turbo:before-visit', this.handleBeforeVisit)
    window.addEventListener('beforeunload', this.saveScroll)
  }

  disconnect () {
    this.#saveScrollPosition()

    if (this.hasMenuTarget) {
      this.menuTarget.removeEventListener('scroll', this.saveScroll)
    }
    document.removeEventListener('turbo:before-visit', this.handleBeforeVisit)
    window.removeEventListener('beforeunload', this.saveScroll)
  }

  toggle () {
    this.openedValue = !this.openedValue
  }

  openedValueChanged (opened) {
    this.element.classList.toggle('body-overflow', opened)

    if (this.hasMenuTarget) {
      this.menuTarget.classList.toggle('body__sidebar-opened', opened)
    }
  }

  #saveScrollPosition () {
    if (!this.hasMenuTarget) return

    window.sessionStorage.setItem(SCROLL_KEY, String(this.menuTarget.scrollTop))
  }

  #restoreScrollPosition () {
    if (!this.hasMenuTarget) return

    const saved = window.sessionStorage.getItem(SCROLL_KEY)
    if (saved) this.menuTarget.scrollTop = parseInt(saved, 10)
  }
}
